<div
  class="mw-date-range-picker mat-elevation-z8 double"
  #pickerContainer
  [ngClass]="{
    ltr: locale.direction === 'ltr',
    rtl: this.locale.direction === 'rtl',
    shown: inline,
    hidden: !inline,
    inline: inline
  }"
>
  <div class="ranges" *ngIf="ranges.length > 1">
    <mat-radio-group [(ngModel)]="this.chosenRange">
      <mat-radio-button
        *ngFor="let range of ranges"
        (click)="clickRange($event, range)"
        [value]="range.label"
        [disabled]="isDisabledRange(range)"
      >
        {{ range.label | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="right-container">
    <div class="calendars">
      <div class="calendar left">
        <div class="calendar-table">
          <div
            class="calendar-header"
            [style.padding-left]="
              options.showWeekNumbers || options.showISOWeekNumbers
                ? '36px'
                : '0'
            "
          >
            <ng-container>
              <div>
                <div
                  (click)="clickPrev(sideEnum.left)"
                  class="prev available"
                  *ngIf="
                    !calendarVariables.left.minDate ||
                    (+calendarVariables.left.minDate <
                      +calendarVariables.left.calendar.firstDay &&
                      (!options.linkedCalendars || true))
                  "
                >
                  <button mat-icon-button color="primary">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
            <div class="month drp-animate">
              <ng-container
                *ngIf="
                  options.showDropdowns && calendarVariables.left.dropdowns
                "
              >
                <div class="dropdowns monthselect">
                  {{
                    calendarVariables &&
                      calendarVariables.left &&
                      this.locale.monthNames[
                        calendarVariables.left.calendar[1][1].month()
                      ]
                  }}
                  <select (change)="monthChanged($event, sideEnum.left)">
                    <option
                      [disabled]="
                        (calendarVariables.left.dropdowns.inMinYear &&
                          m < calendarVariables.left.minDate.month()) ||
                        (calendarVariables.left.dropdowns.inMaxYear &&
                          m > calendarVariables.left.maxDate.month())
                      "
                      *ngFor="
                        let m of calendarVariables.left.dropdowns.monthArrays
                      "
                      [value]="m"
                      [selected]="
                        calendarVariables.left.dropdowns.currentMonth === m
                      "
                    >
                      {{ locale.monthNames[m] }}
                    </option>
                  </select>
                </div>
                <div class="dropdowns yearselect">
                  {{
                    calendarVariables &&
                      calendarVariables.left &&
                      calendarVariables.left.calendar[1][1].format(' YYYY')
                  }}
                  <select (change)="yearChanged($event, sideEnum.left)">
                    <option
                      *ngFor="
                        let y of calendarVariables.left.dropdowns.yearArrays
                      "
                      [selected]="
                        y === calendarVariables.left.dropdowns.currentYear
                      "
                    >
                      {{ y }}
                    </option>
                  </select>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  !options.showDropdowns || !calendarVariables.left.dropdowns
                "
              >
                {{
                  calendarVariables &&
                    calendarVariables.left &&
                    this.locale.monthNames[
                      calendarVariables.left.calendar[1][1].month()
                    ]
                }}
                {{
                  calendarVariables &&
                    calendarVariables.left &&
                    calendarVariables.left.calendar[1][1].format(' YYYY')
                }}
              </ng-container>
            </div>
            <ng-container>
              <div>
                <div
                  class="next available"
                  (click)="clickNext(sideEnum.left)"
                  *ngIf="
                    (!calendarVariables.left.maxDate ||
                      +calendarVariables.left.maxDate <
                        +calendarVariables.left.calendar.lastDay) &&
                    !options.linkedCalendars &&
                    +calendarVariables.left.calendar.lastDay !==
                      +calendarVariables.right.calendar.lastDay
                  "
                >
                  <button mat-icon-button color="primary">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
          <table *ngIf="calendarVariables">
            <thead>
              <tr class="head-week">
                <th
                  *ngIf="options.showWeekNumbers || options.showISOWeekNumbers"
                  class="week"
                >
                  <span>{{ this.locale.weekLabel | translate }}</span>
                </th>
                <th *ngFor="let dayofweek of daysOfWeek">
                  <span>{{ dayofweek }}</span>
                </th>
              </tr>
            </thead>
            <tbody class="drp-animate" (mouseleave)="onCalendarsMouseLeave()">
              <tr
                *ngFor="let row of calendarVariables.left.calRows"
                [class]="calendarVariables.left.classes[row].classList"
              >
                <!-- add week number -->
                <td class="week" *ngIf="showWeekNumbers()">
                  <span>
                    {{ getWeek(sideEnum.left, row) }}
                  </span>
                </td>
                <!-- cal -->
                <td
                  *ngFor="let col of calendarVariables.left.calCols"
                  [class]="calendarVariables.left.classes[row][col]"
                  (click)="clickDate($event, sideEnum.left, row, col)"
                  (mouseenter)="hoverDate($event, sideEnum.left, row, col)"
                >
                  <span>
                    <span>
                      {{
                        calendarVariables.left.calendar[row][col] &&
                          calendarVariables.left.calendar[row][col].date()
                      }}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="calendar right">
        <div
          class="calendar-header"
          [style.padding-left]="
            options.showWeekNumbers || options.showISOWeekNumbers ? '36px' : '0'
          "
        >
          <ng-container>
            <div>
              <div
                (click)="clickPrev(sideEnum.right)"
                class="prev available"
                *ngIf="
                  !this.options.linkedCalendars &&
                  (!calendarVariables.right.minDate ||
                    +calendarVariables.right.minDate <
                      +calendarVariables.right.calendar.firstDay) &&
                  +calendarVariables.left.calendar.lastDay !==
                    +calendarVariables.right.calendar.lastDay
                "
              >
                <button mat-icon-button color="primary">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
          <div class="month">
            <ng-container
              *ngIf="options.showDropdowns && calendarVariables.right.dropdowns"
            >
              <div class="dropdowns monthselect">
                {{
                  calendarVariables &&
                    calendarVariables.right &&
                    this.locale.monthNames[
                      calendarVariables.right.calendar[1][1].month()
                    ]
                }}
                <select (change)="monthChanged($event, sideEnum.right)">
                  <option
                    [disabled]="
                      (calendarVariables.right.dropdowns.inMinYear &&
                        m < calendarVariables.right.minDate.month()) ||
                      (calendarVariables.right.dropdowns.inMaxYear &&
                        m > calendarVariables.right.maxDate.month())
                    "
                    *ngFor="
                      let m of calendarVariables.right.dropdowns.monthArrays
                    "
                    [value]="m"
                    [selected]="
                      calendarVariables.right.dropdowns.currentMonth === m
                    "
                  >
                    {{ locale.monthNames[m] }}
                  </option>
                </select>
              </div>
              <div class="dropdowns yearselect">
                {{
                  calendarVariables &&
                    calendarVariables.right &&
                    calendarVariables.right.calendar[1][1].format(' YYYY')
                }}
                <select (change)="yearChanged($event, sideEnum.right)">
                  <option
                    *ngFor="
                      let y of calendarVariables.right.dropdowns.yearArrays
                    "
                    [selected]="
                      y === calendarVariables.right.dropdowns.currentYear
                    "
                  >
                    {{ y }}
                  </option>
                </select>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                !options.showDropdowns || !calendarVariables.right.dropdowns
              "
            >
              {{
                calendarVariables &&
                  calendarVariables.right &&
                  this.locale.monthNames[
                    calendarVariables.right.calendar[1][1].month()
                  ]
              }}
              {{
                calendarVariables &&
                  calendarVariables.right &&
                  calendarVariables.right.calendar[1][1].format(' YYYY')
              }}
            </ng-container>
          </div>
          <ng-container>
            <div>
              <div
                class="next available"
                (click)="clickNext(sideEnum.right)"
                *ngIf="
                  !calendarVariables.right.maxDate ||
                  +calendarVariables.right.maxDate >
                    +calendarVariables.right.calendar.lastDay
                "
              >
                <button mat-icon-button color="primary">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="calendar-table">
          <table *ngIf="calendarVariables">
            <thead>
              <tr class="head-week">
                <th
                  *ngIf="options.showWeekNumbers || options.showISOWeekNumbers"
                  class="week"
                >
                  <span>{{ this.locale.weekLabel | translate }}</span>
                </th>
                <th *ngFor="let dayofweek of daysOfWeek">
                  <span>{{ dayofweek }}</span>
                </th>
              </tr>
            </thead>
            <tbody (mouseleave)="onCalendarsMouseLeave()">
              <tr
                *ngFor="let row of calendarVariables.right.calRows"
                [class]="calendarVariables.right.classes[row].classList"
              >
                <td class="week" *ngIf="showWeekNumbers()">
                  <span>
                    {{ getWeek(sideEnum.right, row) }}
                  </span>
                </td>
                <td
                  *ngFor="let col of calendarVariables.right.calCols"
                  [class]="calendarVariables.right.classes[row][col]"
                  (click)="clickDate($event, sideEnum.right, row, col)"
                  (mouseenter)="hoverDate($event, sideEnum.right, row, col)"
                >
                  <span>
                    <span>
                      {{
                        calendarVariables.right.calendar[row][col] &&
                          calendarVariables.right.calendar[row][col].date()
                      }}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="bottombar">
      <div class="bottombar-range">
        <div class="bottombar-range__dates" *ngIf="startDate">
          {{ startDate | date: locale.format }} {{ this.locale.separator }}
          <span *ngIf="endDate">{{ endDate | date: locale.format }}</span>
          <span *ngIf="!endDate && endHoverDate" class="hover">
            {{ formattedDate | date: locale.format }}
          </span>
        </div>
        <div class="bottombar-range__duration" *ngIf="durationInDays > 0">
          {{
            (durationInDays === 1 ? locale.dayLabel : locale.daysLabel)
              | translate
          }}:
          {{ durationInDays }}
        </div>
        <div
          class="bottombar-range__duration hover"
          *ngIf="!endDate && hoverDurationInDays > 0"
        >
          {{
            (hoverDurationInDays === 1 ? locale.dayLabel : locale.daysLabel)
              | translate
          }}:
          {{ hoverDurationInDays }}
        </div>
      </div>
      <div class="buttons" *ngIf="!options.autoApply">
        <button mat-flat-button color="accent" (click)="clickApply($event)">
          {{ locale.applyLabel | translate }}
        </button>
        <button mat-button (click)="clickCancel($event)">
          {{ locale.cancelLabel | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
